"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SimpleContactDetail = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTransitionGroup = require("react-transition-group");
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ContactDetail(_ref) {
  var header = _ref.header,
    className = _ref.className,
    tabs = _ref.tabs;
  var _useTheme = (0, _styles.useTheme)(),
    palette = _useTheme.palette;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  (0, _react.useEffect)(function () {
    setActiveTab(0);
  }, [tabs.map(function (each) {
    return each.label;
  }).join('-')]);
  function handleChange(e, newValue) {
    setActiveTab(newValue);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-10 flex-grow-0 bg-app dark:shadow-deep",
    style: {
      boxShadow: palette.type === _constants.themeMode.DARK ? undefined : '0 0px 20px rgba(0,0,0,.035), 0 0px 20px rgba(0,0,0,.035)'
    }
  }, header, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    value: activeTab % tabs.length,
    onChange: handleChange,
    className: "px-4",
    textColor: "primary",
    indicatorColor: "primary",
    variant: "fullWidth",
    TabIndicatorProps: {
      style: {
        height: '3px',
        width: "".concat((100 / tabs.length).toFixed(2), "%")
      }
    }
  }, tabs.map(function (each, index) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      disableRipple: true,
      label: each.label,
      key: each.label,
      className: (0, _classnames["default"])('!text-xs !min-w-0', {
        '!text-light': activeTab !== index
      })
    });
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 overflow-y-auto z-0"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.SwitchTransition, {
    mode: "out-in"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    key: activeTab,
    addEndListener: function addEndListener(node, done) {
      node.addEventListener('transitionend', done, false);
    },
    classNames: "fade"
  }, tabs[activeTab].node))));
}
var _default = exports["default"] = ContactDetail;
var SimpleContactDetail = exports.SimpleContactDetail = function SimpleContactDetail(_ref2) {
  var avatar = _ref2.avatar,
    name = _ref2.name,
    email = _ref2.email,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full overflow-y-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-8 pb-4 px-6 text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center pb-2"
  },
  /*#__PURE__*/
  // $FlowFixMe
  _react["default"].cloneElement(avatar, {
    className: '!w-20 !h-20 text-3xl'
  })), name && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-dark font-bold truncate"
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm text-gray-light truncate"
  }, email)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-6"
  }, _react["default"].Children.map(children, function (each) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-full my-6 dark:bg-card",
      style: {
        boxShadow: '0 0px 20px rgba(0,0,0,.035), 0 0px 20px rgba(0,0,0,.035)'
      }
    }, each);
  })));
};
//# sourceMappingURL=index.js.map